import { Wrench, Clock, CheckCircle2 } from "lucide-react";

function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-100/50 to-blue-100/50" />
      <div className="absolute top-20 left-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob" />
      <div className="absolute top-40 right-10 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000" />
      
      <div className="relative max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl p-4">
              <CheckCircle2 className="h-12 w-12 text-white" />
            </div>
          </div>
          
          <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-4">
            Milestora
          </h1>
          
          {/* Maintenance Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Wrench className="h-16 w-16 text-purple-600 animate-bounce" />
              <div className="absolute -top-1 -right-1">
                <div className="w-3 h-3 bg-blue-600 rounded-full animate-ping" />
              </div>
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Güncelleme Yapılıyor
          </h2>
          
          <p className="text-gray-600 mb-6">
            Sistemi daha iyi hale getirmek için kısa bir güncelleme yapıyoruz. 
            Lütfen birkaç dakika içinde tekrar deneyin.
          </p>
          
          {/* Progress indicator */}
          <div className="mb-6">
            <div className="flex justify-center items-center gap-2 text-sm text-gray-500">
              <Clock className="h-4 w-4 animate-pulse" />
              <span>Tahmini Süre: 2-3 dakika</span>
            </div>
          </div>
          
          {/* Loading animation */}
          <div className="flex justify-center gap-2">
            <div className="w-3 h-3 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-3 h-3 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-3 h-3 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          
          {/* Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Sorularınız için:{" "}
              <a 
                href="mailto:milestora@enerotomasyon.com.tr" 
                className="text-purple-600 hover:text-purple-700 font-medium"
              >
                milestora@enerotomasyon.com.tr
              </a>
            </p>
          </div>
        </div>
        
        {/* Auto-refresh info */}
        <p className="text-center text-sm text-gray-600 mt-4">
          Sayfa otomatik olarak yenilenecek...
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
